import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import TextField from "components/TextField";
import useText from "constants/text";
import { NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import React from "react";
import { parseToInt } from "utils";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: "2rem 3rem 0rem 0rem",
      "&.MuiAutocomplete-tag": {
        backgroundColor: "#399ebf",
      },
      [theme.breakpoints.down("xs")]: {
        padding: "2rem 0rem 0rem 0rem",
      },
    },
  })
);

export default function Details() {
  const { text } = useText();
  const classes = useStyles();

  const { requestQuote, setRequestQuote, setStep } = React.useContext(NewRequestQuoteContext);
  React.useEffect(() => {
    setStep(2);
  });

  const onChangeInputValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequestQuote({ ...requestQuote, additionnalInfos: event.target.value });
  };

  const handleDispatcherChange = (event: any) => {
    setRequestQuote({
      ...requestQuote,
      dispatcher: {
        ...requestQuote.dispatcher,
        [event?.target?.name]: parseToInt(event?.target?.value),
      },
    });
  };

  const handleHandlerChange = (event: any) => {
    setRequestQuote({
      ...requestQuote,
      handler: {
        ...requestQuote.handler,
        [event?.target?.name]: parseToInt(event?.target?.value),
      },
    });
  };
  return (
    <NewRequestQuoteContext.Consumer>
      {({ requestQuote, fieldError }) => (
        <Grid container spacing={4} className={classes.root}>
          <Grid item xs={12}>
            <TextField
              label={text.requestQuote.does_it_require_dispatcher}
              name="numberOfDispatcher"
              fullWidth
              onChange={handleDispatcherChange}
              value={requestQuote?.dispatcher?.numberOfDispatcher}
              rowsMax={7}
              placeholder={text.all.how_many}
              type="number"
              InputProps={{ inputProps: { min: 1, max: 100 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={text.requestQuote.does_it_require_handler}
              name="numberOfHandler"
              fullWidth
              onChange={handleHandlerChange}
              value={requestQuote?.handler?.numberOfHandler}
              rowsMax={7}
              placeholder={text.all.how_many}
              type="number"
              InputProps={{ inputProps: { min: 1 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={text.requestQuote.additionnal_details}
              multiline
              fullWidth
              onChange={onChangeInputValue}
              value={requestQuote?.additionnalInfos}
              rows={4}
            />
          </Grid>
        </Grid>
      )}
    </NewRequestQuoteContext.Consumer>
  );
}
